export const InfoCard = ({ label, value, icon }: { label: string, value: string, icon?: React.ReactNode }) => (
  <div className="bg-gray-50 p-3 rounded-lg">
    <div className="flex items-center space-x-2 text-gray-500 mb-1">
      {icon}
      <span className="text-xs">{label}</span>
    </div>
    <div className="font-medium text-gray-900">{value}</div>
  </div>
);
